// extracted by mini-css-extract-plugin
module.exports = {"LdsRoller":"LoaderSection_LdsRoller__EUlVe","lds-roller":"LoaderSection_lds-roller__1yOGJ"};